import React, { useState, ReactNode } from 'react';
import { AppContext, AppContextValue, AppView } from './AppContextDef';

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [currentView, setCurrentView] = useState<AppView>('main');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const setView = (view: AppView) => {
    setCurrentView(view);
    setError(null);
  };

  const setLoading = (loading: boolean) => {
    setIsLoading(loading);
    if (loading) {
      setError(null);
    }
  };

  const value: AppContextValue = {
    currentView,
    isLoading,
    error,
    setView,
    setLoading,
    setError,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};